const Storage = require('utils/localStorage/Storage');
const { merge } = require('utils/redux/Actions');
const profileApi = require('services/api/profile');

const TARGETERS_CACHE_KEY_PREFIX = 'targetersCache';
const TARGETERS_CACHE_TIME = Storage.MINUTES * 10;

const getTargeterCache = function(targeter) {
    return Storage.session.getItem(`${TARGETERS_CACHE_KEY_PREFIX}_${targeter}`);
};

const getTargetersArray = function () {
    if (!Sephora.targetersToInclude || Sephora.targetersToInclude === '?') {
        return [];
    }

    return decodeURIComponent(Sephora.targetersToInclude)
        .replace(/(\?|&)includeTargeters=/, '')
        .split(',');
};

const setTargeterCache = (targeterName, targeterValue) => {
    Storage.session.setItem(
        `${TARGETERS_CACHE_KEY_PREFIX}_${targeterName}`,
        targeterValue,
        TARGETERS_CACHE_TIME
    );
};

const requestAndSetTargeters = () => (dispatch) => {
    const requiredTargeterNames = getTargetersArray();

    if (requiredTargeterNames.length === 0) {
        return;
    }

    const cachedTargeters = requiredTargeterNames.reduce((acc, targeterName) => {
        const cached = getTargeterCache(targeterName);
        if (cached) {
            acc[targeterName] = cached;
        }
        return acc;
    }, {});
    const canBeFilledByCache = requiredTargeterNames.length === Object.keys(cachedTargeters).length;

    // Set targeters into the redux store if we have them all in cache
    if (canBeFilledByCache) {
        dispatch(merge('targeters', 'results', { targeterResult: cachedTargeters }));
        return;
    }

    profileApi.getTargetersContent(requiredTargeterNames)
        .then((response) => {
            if (response.responseStatus === 200 && response.targeterResult) {
                const { targeterResult } = response;
                for (const targeterName in targeterResult) {
                    if (Object.prototype.hasOwnProperty.call(targeterResult, targeterName)) {
                        setTargeterCache(targeterName, targeterResult[targeterName]);
                    }
                }
                dispatch(merge('targeters', 'results', { targeterResult }));
            } else {
                dispatch(merge('targeters', 'results', {}));
            }
        });
};

module.exports = { requestAndSetTargeters };
